module.exports = __webpack_public_path__ + "img/single_bidding_submit.6758c31c.png";